export default "__VITE_ASSET__45e7e28e__"